export default __webpack_public_path__ + "static/media/j4.718493d6.JPG";